import { makeStyles } from '@surveycake/rc';

const range = `
	display: inline-block;
	position: absolute;
	text-align: center;
	word-break: keep-all;
	cursor: pointer;
	user-select: none;
	transform: translateX(-50%);
`;

const sliderMargin = 12;

export const useStyles = makeStyles([
  [
    'info',
	`
		:lang(ar){
			transform: scaleX(-1);
			direction: rtl;
		}
		display: flex;
		align-items: center;
	`
  ],
  [
    'unit',
    `
		margin-left: auto;
	`
  ],
  [
    'range',
	theme => `
		:lang(ar){
			transform: scaleX(-1);
		}
		position: absolute;
		top: 70px;
		left: 0;
		width: 100%;
		color: ${theme.survey.color.gray}
	`
  ],
  [
    'min',
    `
		${range}
		left: ${sliderMargin}px;
	`
  ],
  [
    'max',
    `
		${range}
		left: calc(100% - ${sliderMargin}px);
	`
  ],
  [
	  'transform',
	  `
		:lang(ar){
			transform: scaleX(-1);
		}
	  `
  ]
]);
